document.addEventListener("DOMContentLoaded", function () {
  let sliderContainer = document.querySelector("[data-slider].blog-container");

  if (sliderContainer) {
    let flkty = new Flickity(sliderContainer, {
      cellSelector: ".featured-article", 
      lazyLoad: 2, 
      freeScroll: false, 
      imagesLoaded: true, 
      draggable: true, 
      cellAlign: "left", 
      wrapAround: true, 
      pageDots: false, 
      contain: false, 
      prevNextButtons: true, 
      initialIndex: 0
    });

    flkty.on("settle", function () {
      flkty.resize();
    });
  }
});
